import { FC } from 'react'
import { Grid } from '@mui/material'
import { Table, DynamicColumn } from 'src/components/ui'
import { SensorDashboardStatistics } from 'src/api'
import { SensorDashboardColumns } from 'src/components/columns/dashboard'

interface SensorDashboardProps {
  sensorStatistics: SensorDashboardStatistics
}

const columns: DynamicColumn<SensorDashboardStatistics>[] = [
  SensorDashboardColumns.SensorsNumber,
  SensorDashboardColumns.FreeSensorsNumber,
  SensorDashboardColumns.AssignedSensorsNumber,
  SensorDashboardColumns.InUseSensorsNumber,
  SensorDashboardColumns.LostSensorsNumber
]

export const SensorDashboard: FC<SensorDashboardProps> = (props) => {
  const { sensorStatistics } = props
  return (
    <Grid container spacing={2}>
      <Grid item container>
        <Table columns={columns} data={[sensorStatistics]} showFooter={false} sx={{ width: '100%' }} />
      </Grid>
    </Grid>
  )
}
